const STORAGE_KEY = 'wassini-language';
export const DEFAULT_LANGUAGE = 'en';
export const LANGUAGE_OPTIONS = [
  { code: 'en', labelKey: 'language.english' },
  { code: 'fr', labelKey: 'language.french' },
];

const LANGUAGE_SET = new Set(LANGUAGE_OPTIONS.map((item) => item.code));

export const TRANSLATIONS = {
  en: {
    'nav.home': 'Home',
    'nav.categories': 'Categories',
    'nav.inquiry': 'Inquiry',
    'nav.support': 'Support',
    'header.search_placeholder': 'Search here',
    'profile.view_profile': 'View profile',
    'profile.order_history': 'Order history',
    'profile.logout': 'Logout',
    'profile.title': 'Account Details',
    'profile.name_label': 'Full name *',
    'profile.name_placeholder': 'First name',
    'profile.phone_label': 'Phone number *',
    'profile.phone_placeholder': 'Phone number',
    'profile.email_label': 'Email *',
    'profile.email_placeholder': 'Email',
    'profile.saved': 'Saved! (placeholder)',
    'profile.fetch_error':
      'Unable to fetch the latest profile details. Showing saved info.',
    'profile.save_button': 'Save changes',
    'header.addresses.title': 'My addresses',
    'header.addresses.add': 'New address',
    'header.addresses.empty': 'No saved addresses yet.',
    'header.addresses.loading': 'Loading addresses…',
    'header.addresses.edit': 'Edit',
    'header.addresses.delete': 'Delete',
    'header.addresses.delete_confirm': 'Delete this address?',
    'header.addresses.delete_error': 'Unable to delete address. Please try again.',
    'header.addresses.manage_link': 'View addresses',
    'addresses.title': 'My addresses',
    'addresses.subtitle': 'Manage your saved delivery locations.',
    'addresses.add': 'Add address',
    'addresses.empty': 'You have no saved addresses.',
    'addresses.loading': 'Loading addresses…',
    'addresses.default': 'Default',
    'addresses.edit': 'Edit',
    'addresses.delete': 'Delete',
    'addresses.delete_confirm': 'Delete this address?',
    'addresses.delete_error': 'Unable to delete the address. Please try again.',
    'addresses.illustration_alt': 'Addresses illustration',
    'addresses.card_title': 'Default destination',
    'addresses.card_subtitle': 'Update your delivery details anytime.',
    'addresses.default_error': 'Unable to set default address. Please try again.',
    'header.addresses.load_error': 'Unable to load addresses right now.',
    'home.top_products': 'Top Products',
    'home.new_arrivals': 'New Arrivals',
    'home.top_brands': 'Top Brands',
    'language.english': 'English',
    'language.french': 'French',
    'products.see_all': 'See all',
    'products.empty': 'No products available right now.',
    'products.add_to_wishlist': 'Add to wishlist',
    'products.you_might_like': 'You Might Also Like',
    'product.choose_color': 'Choose color',
    'product.choose_size': 'Choose size',
    'product.combo_unavailable': 'This color/size combination is not available right now.',
    'product.description_title': 'Description',
    'product.description_fallback':
      'Detailed description coming soon. Reach out to our concierge for more information about this piece.',
    'product.add_to_cart': 'Add to cart',
    'product.add_to_wishlist': 'Add to wishlist',
    'product.added': 'Added to cart!',
    'product.loading': 'Loading product…',
    'product.load_error': 'Unable to load this product.',
    'product.select_options': 'Please select all required options first.',
    'product.color_label': 'Color',
    'product.size_label': 'Size',
    'product.gallery_alt': '{name} view {index}',
    'collections.title': 'Collections',
    'collections.fallback_category': 'Category',
    'collections.highlight_men.title': 'Elegance in simplicity.',
    'collections.highlight_men.description': 'Men collection',
    'collections.highlight_men.alt': 'Menswear highlight',
    'collections.highlight_bags.title': 'Carry style everywhere.',
    'collections.highlight_bags.description': 'Bags collection',
    'collections.highlight_bags.alt': 'Bags highlight',
    'services.aria_label': 'Wassini services',
    'services.delivery.title': 'FREE AND FAST DELIVERY',
    'services.delivery.description': 'Free delivery for all orders over $140',
    'services.support.title': '24/7 CUSTOMER SERVICE',
    'services.support.description': 'Friendly 24/7 customer support',
    'services.guarantee.title': 'MONEY BACK GUARANTEE',
    'services.guarantee.description': 'We return money within 30 days',
    'footer.heading': 'WASSINI LUXURY',
    'footer.address.line1': 'Street,',
    'footer.address.line2': 'to Fidelity bank,',
    'footer.address.line3': 'Dzowulu, Accra, PO Box AH-10208',
    'footer.useful_links': 'Useful Links',
    'footer.about': 'About us',
    'footer.privacy': 'Terms And Conditions',
    'footer.faq': 'FAQs',
    'footer.contact': 'Contact',
    'footer.phone': 'Phone',
    'footer.email': 'Email',
    'footer.rights': 'All Rights Reserved',
    'about.eyebrow': 'Our story',
    'about.heading': 'About Wassini Luxury',
    'about.subtitle': 'Crafting bespoke luxury experiences for every moment.',
    'about.loading': 'Loading about us…',
    'about.empty': 'No information is available yet.',
    'about.error': 'Unable to load the about page right now.',
    'privacy.eyebrow': 'Policies & trust',
    'privacy.heading': 'Terms And Conditions',
    'privacy.subtitle': 'Learn how we protect your data and respect your privacy.',
    'privacy.loading': 'Loading Terms And Conditions',
    'privacy.empty': 'No Terms And Conditions was provided.',
    'privacy.error': 'Unable to lad the Terms And Conditions right now.',
    'banner.aria_label': 'Featured collections',
    'banner.dot_prefix': 'Show slide',
    'products_page.default_heading': 'Products',
    'products_page.products_label': 'products',
    'products_page.category_label': 'Categories',
    'products_page.category_all': 'All',
    'products_page.price_label': 'Price',
    'products_page.sort.placeholder': 'Sort By',
    'products_page.sort.featured': 'Featured',
    'products_page.sort.new_arrivals': 'New Arrivals',
    'products_page.sort.all': 'All Products',
    'products_page.sort.price_asc': 'Price: Low to High',
    'products_page.sort.price_desc': 'Price: High to Low',
    'products_page.sort.name_asc': 'Name: A-Z',
    'products_page.price_range_all': 'All prices',
    'products_page.price_range_under_200': 'Under $200',
    'products_page.price_range_200_500': '$200 - $500',
    'products_page.price_range_500_1000': '$500 - $1000',
    'products_page.price_range_1000_plus': '$1000+',
    'products_page.loading': 'Loading products…',
    'products_page.empty': 'No products found for this filter.',
    'tracking.eyebrow': 'Real-time updates',
    'tracking.title': 'Track your order',
    'tracking.subtitle': 'Enter your order number to get the latest shipment details.',
    'tracking.number_label': 'Order number',
    'tracking.number_placeholder': 'e.g. 12345',
    'tracking.submit': 'Track order',
    'tracking.searching': 'Searching…',
    'tracking.number_required': 'Please enter an order number.',
    'tracking.not_found': 'We could not find an order with that number.',
    'tracking.statuses_heading': 'Shipment statuses',
    'tracking.statuses_empty': 'Statuses are currently unavailable.',
    'tracking.status_fallback': 'Pending update',
    'tracking.results_heading': 'Tracking details',
    'tracking.no_result': 'Enter an order number to see its latest status.',
    'tracking.order_details': 'Order details',
    'tracking.current_status': 'Current status',
    'tracking.last_update': 'Last update',
    'tracking.unknown_date': 'Unknown',
    'tracking.order_date': 'Ordered on',
    'tracking.order_total': 'Total',
    'tracking.order_payment': 'Payment',
    'tracking.order_notes': 'Notes',
    'tracking.order_items_empty': 'No items were linked to this order.',
    'tracking.quantity_label': 'Qty: {{count}}',
    'tracking.product_fallback': 'Product',
    'tracking.unknown_value': 'Not available',
    'tracking.shipment_details': 'Shipment details',
    'tracking.lines_heading': 'Items in this order',
    'tracking.barcode_label': 'Barcode',
    'tracking.line_price': 'Total',
    'login.title': 'Login',
    'login.phone_label': 'Phone number',
    'login.phone_placeholder': '+1 555 000 000',
    'login.send_otp': 'Send OTP',
    'login.sending': 'Sending...',
    'login.no_account': "Don't have an account?",
    'login.signup': 'Sign Up',
    'login.continue_guest': 'Continue as a guest',
    'login.powered': 'Powered by',
    'login.missing_phone': 'Please enter your phone number.',
    'login.account_not_found': 'Account not found. Please sign up first.',
    'login.otp_sent': 'OTP sent to your phone number.',
    'login.otp_failed': 'Unable to send OTP. Please try again.',
    'signup.title': 'Sign Up',
    'signup.full_name_label': 'Full name',
    'signup.full_name_placeholder': 'Jane Doe',
    'signup.phone_label': 'Phone number',
    'signup.phone_placeholder': '+1 555 000 000',
    'signup.create_cta': 'Sign Up',
    'signup.creating': 'Creating Account...',
    'signup.already': 'Already have an account?',
    'signup.login': 'Login',
    'signup.status_name_required': 'Please enter your full name.',
    'signup.status_phone_required': 'Please enter your phone number.',
    'signup.status_create_failed':
      'Unable to create your account. Please try again.',
    'signup.status_otp_failed': 'Unable to start sign up.',
    'signup.status_otp_sent': 'We just sent you a verification code.',
    'signup.powered': 'Powered by',
    'otp.tagline': 'fine arts and luxe',
    'otp.no_request_title': 'Verification',
    'otp.no_request_message':
      'We could not find an active verification request. Please start again.',
    'otp.back_to_login': 'Back to Login',
    'otp.title': 'Enter OTP',
    'otp.hint_prefix': 'We sent a 6-digit code to',
    'otp.hint_suffix': 'Enter it below to finish logging in.',
    'otp.code_label': 'Verification code',
    'otp.code_placeholder': '______',
    'otp.verifying': 'Verifying…',
    'otp.submit': 'Verify & Continue',
    'otp.missing_code': 'Please enter the 6-digit code sent to you.',
    'otp.verify_failed': 'Unable to verify the code. Please try again.',
    'otp.success': 'Success! Redirecting you to Wassini...',
    'otp.login_failed':
      'Unable to complete login. Please try again.',
    'otp.wrong_number': 'Entered the wrong number?',
    'otp.start_over': 'Start over',
    'otp.display_phone_fallback': 'your phone number',
    'otp.powered': 'Powered by',
    'inquiry.hero_title': 'What can we get you?',
    'inquiry.hero_description':
      'Provide a photo or a link to the product you’re looking for.',
    'inquiry.hero_alt': 'Shopping assistant',
    'inquiry.order_label': 'Your order',
    'inquiry.quick_placeholder': 'Enter item name or link',
    'inquiry.items_title': 'Your items',
    'inquiry.item_single': 'item',
    'inquiry.item_plural': 'items',
    'inquiry.message_add_item': 'Please add at least one item.',
    'inquiry.message_checkout_error':
      'Unable to open checkout right now. Please try again in a moment.',
    'inquiry.remove_item': 'Remove item',
    'inquiry.opening_checkout': 'Opening checkout…',
    'inquiry.confirm_button': 'Confirm inquiry',
    'inquiry_modal.eyebrow': 'Item details',
    'inquiry_modal.edit_title': 'Edit item',
    'inquiry_modal.add_title': 'Add an item',
    'inquiry_modal.upload_label': 'Upload an image',
    'inquiry_modal.remove_photo': 'Remove',
    'inquiry_modal.add_photo': 'Add photo',
    'inquiry_modal.uploading': 'Uploading…',
    'inquiry_modal.name_label': 'Name / Link *',
    'inquiry_modal.name_placeholder': 'Paste link or write item name',
    'inquiry_modal.price_label': 'Price (USD) *',
    'inquiry_modal.type_label': 'Product Type *',
    'inquiry_modal.type_loading': 'Loading…',
    'inquiry_modal.type_placeholder': 'Select product type',
    'inquiry_modal.type_hint': 'Items over $200 do not require a product type.',
    'inquiry_modal.description_label': 'Describe your product clearly *',
    'inquiry_modal.description_placeholder': 'Brand - Color - Size - Model',
    'inquiry_modal.cancel': 'Cancel',
    'inquiry_modal.save': 'Save item',
    'inquiry_modal.upload_failed': 'Failed to upload image',
    'inquiry_modal.fill_all_fields':
      'Please fill all fields and pick a product type.',
    'inquiry_modal.fill_required_fields': 'Please fill all required fields.',
    'cart.empty_title': 'Your cart is empty',
    'cart.empty_description':
      'Browse products and add them to your cart to continue.',
    'cart.empty_button': 'Browse categories',
    'cart.eyebrow': 'Your cart',
    'cart.item': 'item',
    'cart.items': 'items',
    'cart.clear': 'Clear cart',
    'cart.no_image': 'No image',
    'cart.shipping_prefix': 'Shipping:',
    'cart.decrease': 'Decrease quantity',
    'cart.increase': 'Increase quantity',
    'cart.remove': 'Remove',
    'cart.remove_confirm_title': 'Remove item?',
    'cart.remove_confirm_description':
      'Do you want to remove this product from your cart?',
    'cart.remove_confirm_cancel': 'Keep item',
    'cart.remove_confirm_confirm': 'Remove',
    'cart.order_summary': 'Order Summary',
    'cart.subtotal': 'Subtotal',
    'cart.shipping': 'Shipping',
    'cart.total': 'Total',
    'cart.checkout': 'Checkout',
    'favorites.title': 'Wishlist',
    'favorites.loading': 'Loading favorites…',
    'favorites.empty_title': 'Your wishlist is empty!',
    'favorites.empty_cta': 'You have not added any favorites yet.',
    'favorites.empty_button': 'Return to shop',
    'favorites.table.product': 'Product',
    'favorites.table.price': 'Price',
    'favorites.table.action': 'Action',
    'favorites.remove': 'Remove favorite',
    'favorites.no_image': 'No image',
    'favorites.color_prefix': 'Color:',
    'favorites.adding': 'Adding…',
    'favorites.add_to_cart': 'Add to cart',
    'favorites.error_login': 'You must be logged in to view favorites.',
    'favorites.error_generic':
      'We could not load your favorites. Please try again later.',
    'checkout.title': 'Checkout',
    'checkout.shipping_address': 'Shipping Address',
    'checkout.address_loading': 'Loading your addresses…',
    'checkout.address_error_missing_customer':
      'We could not detect your customer id. Please sign in again before continuing.',
    'checkout.address_error_generic':
      'Unable to fetch your addresses right now. Please try again.',
    'checkout.address_add_hint': 'Add an address to continue with your order.',
    'checkout.add_address': 'Add new address',
    'checkout.address_empty_hint':
      'We could not find any address. Please add one from the mobile app or contact support.',
    'checkout.address_field_label': 'Address',
    'checkout.address_no_details': 'No additional address details available.',
    'checkout.payment_method': 'Payment method',
    'checkout.payment_cod': 'Cash On Delivery',
    'checkout.delivery_instructions': 'Delivery instructions',
    'checkout.delivery_placeholder': 'Add any delivery instructions (optional)',
    'checkout.place_order': 'Place Order',
    'checkout.placing_order': 'Placing order…',
    'checkout.place_order_error_online':
      'Online payments are not available yet. Please choose Cash on Delivery.',
    'checkout.order_summary': 'Order summary',
    'checkout.summary_subtotal': 'Subtotal',
    'checkout.summary_shipping': 'Shipping',
    'checkout.summary_promo': 'Promo',
    'checkout.summary_total': 'Total',
    'checkout.free_shipping': 'Free',
    'checkout.items_label': 'Items',
    'checkout.item_fallback': 'Item',
    'checkout.aria_decrease': 'Decrease quantity',
    'checkout.aria_increase': 'Increase quantity',
    'checkout.promo_placeholder': 'Promo code',
    'checkout.promo_checking': 'Checking…',
    'checkout.promo_apply': 'Apply',
    'checkout.promo_invalid': 'Invalid promo code.',
    'checkout.promo_error': 'Unable to verify promo code right now.',
    'checkout.promo_remove': 'Remove promo',
    'checkout.shipping_included': 'Included',
    'checkout.promo_badge_cash': '-{amount}',
    'checkout.place_order_error_generic':
      'Unable to place the order. Please try again.',
    'checkoutInquiry.title_cart': 'Checkout',
    'checkoutInquiry.title_inquiry': 'Review your inquiry',
    'checkoutInquiry.description_cart':
      'Confirm your order details and address before placing your order.',
    'checkoutInquiry.description_inquiry':
      'Confirm the delivery details and destination before submitting your request.',
    'checkoutInquiry.destination_label': 'Destination',
    'checkoutInquiry.lebanon': 'Lebanon',
    'checkoutInquiry.other_countries': 'Other countries',
    'checkoutInquiry.shipping_hint':
      'Shipping and total will be calculated later for international destinations.',
    'checkoutInquiry.destination_placeholder': 'Destination country',
    'checkoutInquiry.items_heading': 'Items',
    'checkoutInquiry.items_count': 'item',
    'checkoutInquiry.items_count_plural': 'items',
    'checkoutInquiry.item_fallback': 'Item',
    'checkoutInquiry.no_image': 'No image',
    'checkoutInquiry.shipping_prefix': 'Shipping:',
    'checkoutInquiry.select_address': 'Select an address',
    'checkoutInquiry.address_add': 'Add new address',
    'checkoutInquiry.address_hint':
      'We could not find any address. Please add one from the mobile app or contact support.',
    'checkoutInquiry.address_label': 'Address',
    'checkoutInquiry.address_no_details':
      'No additional address details available.',
    'checkoutInquiry.delivery_label': 'Delivery instructions',
    'checkoutInquiry.delivery_placeholder': 'Add any delivery notes',
    'checkoutInquiry.summary_items': 'Items',
    'checkoutInquiry.summary_subtotal': 'Subtotal',
    'checkoutInquiry.summary_shipping': 'Shipping',
    'checkoutInquiry.summary_total': 'Total payment',
    'checkoutInquiry.submitting': 'Submitting…',
    'checkoutInquiry.submit': 'Confirm & submit',
    'checkoutInquiry.place_order_error_missing_customer':
      'Missing customer information. Please sign in again.',
    'checkoutInquiry.place_order_error_generic':
      'Unable to place the order. Please try again.',
    'checkoutInquiry.shipping_tbd': 'TBD',
    'checkoutInquiry.shipping_included': 'Included',
    'add_address.browser_only': 'Google Maps is only available in the browser.',
    'add_address.missing_api_key': 'Missing Google Maps API key.',
    'add_address.maps_key_missing':
      'Google Maps key is not configured. Please enter coordinates manually.',
    'add_address.maps_load_error':
      'Unable to load Google Maps. Please enter coordinates manually.',
    'add_address.sign_in_required': 'Please sign in again before adding an address.',
    'add_address.required_fields': 'Name and city are required.',
    'add_address.save_error':
      'Unable to save this address right now. Please try again.',
    'add_address.title': 'New address',
    'add_address.edit_title': 'Edit address',
    'add_address.close': 'Close',
    'add_address.name_label': 'Address name *',
    'add_address.name_placeholder': 'e.g. Home, Office',
    'add_address.street_label': 'Street',
    'add_address.street_placeholder': 'Main street',
    'add_address.building_label': 'Building',
    'add_address.building_placeholder': 'Building',
    'add_address.apartment_label': 'Apartment',
    'add_address.apartment_placeholder': 'Apartment',
    'add_address.city_label': 'City *',
    'add_address.city_placeholder': 'City',
    'add_address.description_label': 'Location description',
    'add_address.description_placeholder': 'Nearby landmarks, directions…',
    'add_address.pin_label': 'Pin on map *',
    'add_address.search_placeholder': 'Search a location in Lebanon',
    'add_address.searching': 'Searching…',
    'add_address.cancel': 'Cancel',
    'add_address.save': 'Save address',
    'add_address.saving': 'Saving…',
    'add_address.pin_required': 'Please select a point on the map.',
    'support.title': 'Get in touch with us',
    'support.description':
      'For more information about our products & services, feel free to drop us a message. Our staff is always here to help you out.',
    'support.contact_us': 'Contact us',
    'support.email': 'Email',
    'support.image_alt': 'Customer support illustration',
    'support.form.name': 'Full name',
    'support.form.name_placeholder': 'Your name',
    'support.form.phone': 'Phone number',
    'support.form.phone_placeholder': '+1 555 000 000',
    'support.form.email': 'Email address',
    'support.form.email_placeholder': 'you@email.com',
    'support.form.subject': 'Subject',
    'support.form.message': 'Message',
    'support.form.message_placeholder': 'Your message',
    'support.form.submit': 'Send message',
    'support.form.submitting': 'Sending…',
    'support.form.validation_error':
      'Please fill in your name, phone number, and message.',
    'support.form.success':
      'Your message has been sent. We will reach out shortly.',
    'support.form.error_generic':
      'Something went wrong. Please try again later.',
    'support.subject_picker.title': 'Select subject',
    'support.subject_picker.close': 'Close',
    'support.subject.other': 'Other',
    'support.subject.order': 'Order issue',
    'support.subject.payment': 'Payment',
    'support.subject.general': 'General',
    'faq.title': 'Frequently Asked Questions',
    'faq.description': 'Find quick answers to common questions about Wassini services.',
    'faq.loading': 'Loading questions…',
    'faq.empty': 'We could not find any FAQs at this time.',
    'faq.select_prompt': 'Select a question to view the answer.',
    'search.results_title': 'Search results',
    'search.results_subtitle': 'Showing matches for "{query}"',
    'search.no_query': 'Enter a keyword to search products, brands, or categories.',
    'search.preview_no_results': 'No matches yet.',
    'search.loading': 'Searching…',
    'search.view_more': 'View more results',
    'search.submit': 'Search',
    'search.products_label': 'Products',
    'search.brands_label': 'Brands',
    'search.categories_label': 'Categories',
    'search.no_results': 'No results found.',
    'orders.title': 'Orders History',
    'orders.filter.pending': 'Pending',
    'orders.filter.completed': 'Completed',
    'orders.empty_pending': 'You have no pending orders.',
    'orders.empty_completed': 'No completed orders yet.',
    'orders.loading': 'Loading orders…',
    'orders.columns.id': 'Number ID',
    'orders.columns.date': 'Dates',
    'orders.columns.status': 'Status',
    'orders.columns.price': 'Price',
    'orders.status.pending': 'Pending',
    'orders.status.completed': 'Completed',
    'addresses.select':'Select Delivery Address'
  },
  fr: {
    'nav.home': 'Accueil',
    'nav.categories': 'Catégories',
    'nav.inquiry': 'Demande',
    'nav.support': 'Support',
    'header.search_placeholder': 'Rechercher ici',
    'profile.view_profile': 'Voir le profil',
    'profile.order_history': 'Historique des commandes',
    'profile.logout': 'Se déconnecter',
    'profile.title': 'Informations du compte',
    'profile.name_label': 'Nom complet *',
    'profile.name_placeholder': 'Prénom',
    'profile.phone_label': 'Numéro de téléphone *',
    'profile.phone_placeholder': 'Numéro de téléphone',
    'profile.email_label': 'Email *',
    'profile.email_placeholder': 'Email',
    'profile.saved': 'Enregistré ! (temporaire)',
    'profile.fetch_error':
      'Impossible de récupérer les dernières informations. Affichage des données enregistrées.',
    'profile.save_button': 'Enregistrer',
    'header.addresses.title': 'Mes adresses',
    'header.addresses.add': 'Nouvelle adresse',
    'header.addresses.empty': 'Aucune adresse enregistrée.',
    'header.addresses.loading': 'Chargement des adresses…',
    'header.addresses.edit': 'Modifier',
    'header.addresses.delete': 'Supprimer',
    'header.addresses.delete_confirm': 'Supprimer cette adresse ?',
    'header.addresses.delete_error': "Impossible de supprimer l'adresse. Veuillez réessayer.",
    'header.addresses.load_error': 'Impossible de charger les adresses pour le moment.',
    'header.addresses.manage_link': 'Voir les adresses',
    'addresses.title': 'Mes adresses',
    'addresses.subtitle': 'Gérez vos lieux de livraison enregistrés.',
    'addresses.add': 'Ajouter une adresse',
    'addresses.empty': "Vous n'avez aucune adresse enregistrée.",
    'addresses.loading': 'Chargement des adresses…',
    'addresses.default': 'Par défaut',
    'addresses.edit': 'Modifier',
    'addresses.delete': 'Supprimer',
    'addresses.delete_confirm': 'Supprimer cette adresse ?',
    'addresses.delete_error':
      "Impossible de supprimer l'adresse. Veuillez réessayer.",
    'addresses.illustration_alt': 'Illustration des adresses',
    'addresses.card_title': 'Destination par défaut',
    'addresses.card_subtitle': 'Mettez à jour vos lieux de livraison à tout moment.',
    'addresses.default_error':
      "Impossible de définir l'adresse par défaut. Veuillez réessayer.",
    'home.top_products': 'Produits phares',
    'home.new_arrivals': 'Nouveautés',
    'home.top_brands': 'Meilleures marques',
    'language.english': 'Anglais',
    'language.french': 'Français',
    'products.see_all': 'Voir tout',
    'products.empty': 'Aucun produit disponible pour le moment.',
    'products.add_to_wishlist': 'Ajouter à la liste de souhaits',
    'products.you_might_like': 'Vous pourriez aussi aimer',
    'product.choose_color': 'Choisir la couleur',
    'product.choose_size': 'Choisir la taille',
    'product.combo_unavailable': 'Cette combinaison couleur/taille n’est pas disponible pour le moment.',
    'product.description_title': 'Description',
    'product.description_fallback':
      'Bientôt une description détaillée. Contactez notre conciergerie pour plus d’informations sur cette pièce.',
    'product.add_to_cart': 'Ajouter au panier',
    'product.add_to_wishlist': 'Ajouter à la liste de souhaits',
    'product.added': 'Ajouté au panier !',
    'product.loading': 'Chargement du produit…',
    'product.load_error': 'Impossible de charger ce produit.',
    'product.select_options': 'Veuillez d’abord sélectionner toutes les options requises.',
    'product.color_label': 'Couleur',
    'product.size_label': 'Taille',
    'product.gallery_alt': 'Vue {index} de {name}',
    'collections.title': 'Collections',
    'collections.fallback_category': 'Catégorie',
    'collections.highlight_men.title': 'L’élégance en toute simplicité.',
    'collections.highlight_men.description': 'Collection homme',
    'collections.highlight_men.alt': 'Sélection mode homme',
    'collections.highlight_bags.title': 'Emportez le style partout.',
    'collections.highlight_bags.description': 'Collection de sacs',
    'collections.highlight_bags.alt': 'Sélection de sacs',
    'services.aria_label': 'Services Wassini',
    'services.delivery.title': 'LIVRAISON GRATUITE ET RAPIDE',
    'services.delivery.description':
      'Livraison gratuite pour toute commande supérieure à 140 $',
    'services.support.title': 'SERVICE CLIENT 24/7',
    'services.support.description': 'Support client amical 24h/24 et 7j/7',
    'services.guarantee.title': 'GARANTIE DE REMBOURSEMENT',
    'services.guarantee.description': 'Remboursement sous 30 jours',
    'footer.heading': 'WASSINI LUXURY',
    'footer.address.line1': 'Rue,',
    'footer.address.line2': 'près de Fidelity Bank,',
    'footer.address.line3': 'Dzowulu, Accra, BP AH-10208',
    'footer.useful_links': 'Liens utiles',
    'footer.about': 'À propos de nous',
    'footer.privacy': 'Conditions Générales d’Utilisation',
    'footer.faq': 'FAQ',
    'footer.contact': 'Contact',
    'footer.phone': 'Téléphone',
    'footer.email': 'Email',
    'footer.rights': 'Tous droits réservés',
    'about.eyebrow': 'Notre histoire',
    'about.heading': 'À propos de Wassini Luxury',
    'about.subtitle': 'Nous créons des expériences de luxe sur mesure pour chaque moment.',
    'about.loading': 'Chargement de notre histoire…',
    'about.empty': "Aucune information n'est disponible pour le moment.",
    'about.error': "Impossible de charger la page à propos pour l'instant.",
    'privacy.eyebrow': 'Politiques et confiance',
    'privacy.heading': 'Conditions Générales d’Utilisation',
    'privacy.subtitle': 'Découvrez comment nous protégeons vos données et respectons votre vie privée.',
    'privacy.loading': 'Chargement de conditions Générales d’Utilisation…',
    'privacy.empty': 'Aucune conditions Générales d’Utilisation fournie.',
    'privacy.error': "Impossible de charger les conditions Générales d’Utilisation pour l'instant.",
    'banner.aria_label': 'Collections vedettes',
    'banner.dot_prefix': 'Afficher la diapositive',
    'products_page.default_heading': 'Produits',
    'products_page.products_label': 'produits',
    'products_page.category_label': 'Catégories',
    'products_page.category_all': 'Tous',
    'products_page.price_label': 'Prix',
    'products_page.sort.placeholder': 'Trier par',
    'products_page.sort.featured': 'En vedette',
    'products_page.sort.new_arrivals': 'Nouveautés',
    'products_page.sort.all': 'Tous les produits',
    'products_page.sort.price_asc': 'Prix : du plus bas au plus élevé',
    'products_page.sort.price_desc': 'Prix : du plus élevé au plus bas',
    'products_page.sort.name_asc': 'Nom : A-Z',
    'products_page.price_range_all': 'Tous les prix',
    'products_page.price_range_under_200': 'Moins de 200 $',
    'products_page.price_range_200_500': '200 $ - 500 $',
    'products_page.price_range_500_1000': '500 $ - 1000 $',
    'products_page.price_range_1000_plus': '1000 $+',
    'products_page.loading': 'Chargement des produits…',
    'products_page.empty': 'Aucun produit trouvé pour ce filtre.',
    'tracking.eyebrow': 'Mises à jour en temps réel',
    'tracking.title': 'Suivez votre commande',
    'tracking.subtitle': 'Entrez votre numéro de commande pour obtenir les dernières informations.',
    'tracking.number_label': 'Numéro de commande',
    'tracking.number_placeholder': 'ex. 12345',
    'tracking.submit': 'Suivre la commande',
    'tracking.searching': 'Recherche…',
    'tracking.number_required': 'Veuillez entrer un numéro de commande.',
    'tracking.not_found': 'Aucune commande trouvée avec ce numéro.',
    'tracking.statuses_heading': 'Statuts d’expédition',
    'tracking.statuses_empty': 'Les statuts ne sont pas disponibles pour le moment.',
    'tracking.status_fallback': 'Mise à jour à venir',
    'tracking.results_heading': 'Détails de suivi',
    'tracking.no_result': 'Entrez un numéro de commande pour voir son statut.',
    'tracking.current_status': 'Statut actuel',
    'tracking.last_update': 'Dernière mise à jour',
    'tracking.unknown_date': 'Inconnu',
    'tracking.order_details': 'Détails de la commande',
    'tracking.order_date': 'Commandé le',
    'tracking.order_total': 'Total',
    'tracking.order_payment': 'Paiement',
    'tracking.order_notes': 'Notes',
    'tracking.order_items_empty': "Aucun article n'est associé à cette commande.",
    'tracking.quantity_label': 'Qté : {{count}}',
    'tracking.product_fallback': 'Produit',
    'tracking.unknown_value': 'Non disponible',
    'tracking.shipment_details': "Détails de l'expédition",
    'tracking.lines_heading': 'Articles de cette commande',
    'tracking.barcode_label': 'Code-barres',
    'tracking.line_price': 'Total',
    'login.title': 'Connexion',
    'login.phone_label': 'Numéro de téléphone',
    'login.phone_placeholder': '+1 555 000 000',
    'login.send_otp': 'Envoyer le code',
    'login.sending': 'Envoi…',
    'login.no_account': "Vous n'avez pas de compte ?",
    'login.signup': "S'inscrire",
    'login.continue_guest': 'Continuer en tant qu’invité',
    'login.powered': 'Propulsé par',
    'login.missing_phone': 'Veuillez entrer votre numéro de téléphone.',
    'login.account_not_found':
      'Compte introuvable. Veuillez vous inscrire d’abord.',
    'login.otp_sent': 'Le code OTP a été envoyé sur votre téléphone.',
    'login.otp_failed': 'Impossible d’envoyer le code OTP. Veuillez réessayer.',
    'signup.title': "S'inscrire",
    'signup.full_name_label': 'Nom complet',
    'signup.full_name_placeholder': 'Jane Doe',
    'signup.phone_label': 'Numéro de téléphone',
    'signup.phone_placeholder': '+1 555 000 000',
    'signup.create_cta': "S'inscrire",
    'signup.creating': 'Création du compte…',
    'signup.already': 'Vous avez déjà un compte ?',
    'signup.login': 'Connexion',
    'signup.status_name_required': 'Veuillez entrer votre nom complet.',
    'signup.status_phone_required': 'Veuillez entrer votre numéro de téléphone.',
    'signup.status_create_failed':
      'Impossible de créer votre compte. Veuillez réessayer.',
    'signup.status_otp_failed':
      "Impossible de démarrer l'inscription.",
    'signup.status_otp_sent': 'Nous venons de vous envoyer un code de vérification.',
    'signup.powered': 'Propulsé par',
    'otp.tagline': 'arts raffinés et luxe',
    'otp.no_request_title': 'Vérification',
    'otp.no_request_message':
      "Nous n'avons trouvé aucune demande de vérification active. Veuillez recommencer.",
    'otp.back_to_login': 'Retour à la connexion',
    'otp.title': 'Entrer le code',
    'otp.hint_prefix': 'Nous avons envoyé un code à 6 chiffres à',
    'otp.hint_suffix': 'Saisissez-le ci-dessous pour terminer la connexion.',
    'otp.code_label': 'Code de vérification',
    'otp.code_placeholder': '______',
    'otp.verifying': 'Vérification…',
    'otp.submit': 'Vérifier et continuer',
    'otp.missing_code': 'Veuillez entrer le code à 6 chiffres.',
    'otp.verify_failed':
      'Impossible de vérifier le code. Veuillez réessayer.',
    'otp.success': 'Succès ! Redirection vers Wassini…',
    'otp.login_failed':
      'Impossible de terminer la connexion. Veuillez réessayer.',
    'otp.wrong_number': 'Vous vous êtes trompé de numéro ?',
    'otp.start_over': 'Recommencer',
    'otp.display_phone_fallback': 'votre numéro de téléphone',
    'otp.powered': 'Propulsé par',
    'inquiry.hero_title': 'Que pouvons-nous trouver pour vous ?',
    'inquiry.hero_description':
      'Fournissez une photo ou un lien vers le produit recherché.',
    'inquiry.hero_alt': 'Assistante shopping',
    'inquiry.order_label': 'Votre commande',
    'inquiry.quick_placeholder': 'Saisir le nom de l’article ou un lien',
    'inquiry.items_title': 'Vos articles',
    'inquiry.item_single': 'article',
    'inquiry.item_plural': 'articles',
    'inquiry.message_add_item': 'Veuillez ajouter au moins un article.',
    'inquiry.message_checkout_error':
      'Impossible d’ouvrir le paiement pour le moment. Veuillez réessayer dans un instant.',
    'inquiry.remove_item': 'Supprimer l’article',
    'inquiry.opening_checkout': 'Ouverture du paiement…',
    'inquiry.confirm_button': 'Confirmer la demande',
    'inquiry_modal.eyebrow': 'Détails de l’article',
    'inquiry_modal.edit_title': "Modifier l'article",
    'inquiry_modal.add_title': 'Ajouter un article',
    'inquiry_modal.upload_label': 'Télécharger une image',
    'inquiry_modal.remove_photo': 'Supprimer',
    'inquiry_modal.add_photo': 'Ajouter une photo',
    'inquiry_modal.uploading': 'Téléchargement…',
    'inquiry_modal.name_label': 'Nom / Lien *',
    'inquiry_modal.name_placeholder': 'Collez le lien ou écrivez le nom',
    'inquiry_modal.price_label': 'Prix (USD) *',
    'inquiry_modal.type_label': 'Type de produit *',
    'inquiry_modal.type_loading': 'Chargement…',
    'inquiry_modal.type_placeholder': 'Sélectionner un type de produit',
    'inquiry_modal.type_hint':
      'Les articles de plus de 200 $ ne nécessitent pas de type de produit.',
    'inquiry_modal.description_label':
      'Décrivez clairement votre produit *',
    'inquiry_modal.description_placeholder': 'Marque - Couleur - Taille - Modèle',
    'inquiry_modal.cancel': 'Annuler',
    'inquiry_modal.save': "Enregistrer l'article",
    'inquiry_modal.upload_failed': "Échec du téléchargement de l'image",
    'inquiry_modal.fill_all_fields':
      'Veuillez remplir tous les champs et choisir un type de produit.',
    'inquiry_modal.fill_required_fields':
      'Veuillez remplir tous les champs obligatoires.',
    'cart.empty_title': 'Votre panier est vide',
    'cart.empty_description':
      'Parcourez les produits et ajoutez-les à votre panier pour continuer.',
    'cart.empty_button': 'Voir les catégories',
    'cart.eyebrow': 'Votre panier',
    'cart.item': 'article',
    'cart.items': 'articles',
    'cart.clear': 'Vider le panier',
    'cart.no_image': 'Aucune image',
    'cart.shipping_prefix': 'Livraison :',
    'cart.decrease': 'Diminuer la quantité',
    'cart.increase': 'Augmenter la quantité',
    'cart.remove': 'Retirer',
    'cart.remove_confirm_title': 'Supprimer cet article ?',
    'cart.remove_confirm_description':
      'Voulez-vous retirer ce produit de votre panier ?',
    'cart.remove_confirm_cancel': 'Conserver',
    'cart.remove_confirm_confirm': 'Supprimer',
    'cart.order_summary': 'Récapitulatif de la commande',
    'cart.subtotal': 'Sous-total',
    'cart.shipping': 'Livraison',
    'cart.total': 'Total',
    'cart.checkout': 'Passer au paiement',
    'favorites.title': 'Liste de souhaits',
    'favorites.loading': 'Chargement des favoris…',
    'favorites.empty_title': 'Votre liste de souhaits est vide !',
    'favorites.empty_cta': "Vous n'avez pas encore ajouté de favoris.",
    'favorites.empty_button': 'Retourner à la boutique',
    'favorites.table.product': 'Produit',
    'favorites.table.price': 'Prix',
    'favorites.table.action': 'Action',
    'favorites.remove': 'Supprimer des favoris',
    'favorites.no_image': 'Aucune image',
    'favorites.color_prefix': 'Couleur :',
    'favorites.adding': 'Ajout en cours…',
    'favorites.add_to_cart': 'Ajouter au panier',
    'favorites.error_login':
      'Vous devez être connecté pour voir vos favoris.',
    'favorites.error_generic':
      'Impossible de charger vos favoris. Veuillez réessayer plus tard.',
    'checkout.title': 'Paiement',
    'checkout.shipping_address': 'Adresse de livraison',
    'checkout.address_loading': 'Chargement de vos adresses…',
    'checkout.address_error_missing_customer':
      "Nous n'avons pas pu détecter votre identifiant client. Veuillez vous reconnecter avant de continuer.",
    'checkout.address_error_generic':
      'Impossible de récupérer vos adresses pour le moment. Veuillez réessayer.',
    'checkout.address_add_hint':
      'Ajoutez une adresse pour poursuivre votre commande.',
    'checkout.add_address': 'Ajouter une adresse',
    'checkout.address_empty_hint':
      "Nous n'avons trouvé aucune adresse. Ajoutez-en une via l'application mobile ou contactez le support.",
    'checkout.address_field_label': 'Adresse',
    'checkout.address_no_details':
      "Aucun détail d'adresse supplémentaire disponible.",
    'checkout.payment_method': 'Mode de paiement',
    'checkout.payment_cod': 'Paiement à la livraison',
    'checkout.delivery_instructions': 'Instructions de livraison',
    'checkout.delivery_placeholder':
      'Ajoutez des instructions de livraison (optionnel)',
    'checkout.place_order': 'Passer la commande',
    'checkout.placing_order': 'Commande en cours…',
    'checkout.place_order_error_online':
      'Les paiements en ligne ne sont pas disponibles pour le moment. Veuillez choisir le paiement à la livraison.',
    'checkout.order_summary': 'Récapitulatif',
    'checkout.summary_subtotal': 'Sous-total',
    'checkout.summary_shipping': 'Livraison',
    'checkout.summary_promo': 'Promo',
    'checkout.summary_total': 'Total',
    'checkout.free_shipping': 'Gratuit',
    'checkout.items_label': 'Articles',
    'checkout.item_fallback': 'Article',
    'checkout.aria_decrease': 'Diminuer la quantité',
    'checkout.aria_increase': 'Augmenter la quantité',
    'checkout.promo_placeholder': 'Code promo',
    'checkout.promo_checking': 'Vérification…',
    'checkout.promo_apply': 'Appliquer',
    'checkout.promo_invalid': 'Code promo invalide.',
    'checkout.promo_error':
      'Impossible de vérifier le code promo pour le moment.',
    'checkout.promo_remove': 'Supprimer la promotion',
    'checkout.shipping_included': 'Inclus',
    'checkout.promo_badge_cash': '-{amount}',
    'checkout.place_order_error_generic':
      'Impossible de passer la commande. Veuillez réessayer.',
    'checkoutInquiry.title_cart': 'Paiement',
    'checkoutInquiry.title_inquiry': 'Vérifier votre demande',
    'checkoutInquiry.description_cart':
      'Confirmez les détails de votre commande et votre adresse avant de finaliser.',
    'checkoutInquiry.description_inquiry':
      'Confirmez les détails de livraison et la destination avant d’envoyer votre demande.',
    'checkoutInquiry.destination_label': 'Destination',
    'checkoutInquiry.lebanon': 'Liban',
    'checkoutInquiry.other_countries': 'Autres pays',
    'checkoutInquiry.shipping_hint':
      'Les frais et le total seront calculés ultérieurement pour les destinations internationales.',
    'checkoutInquiry.destination_placeholder': 'Pays de destination',
    'checkoutInquiry.items_heading': 'Articles',
    'checkoutInquiry.items_count': 'article',
    'checkoutInquiry.items_count_plural': 'articles',
    'checkoutInquiry.item_fallback': 'Article',
    'checkoutInquiry.no_image': 'Aucune image',
    'checkoutInquiry.shipping_prefix': 'Livraison :',
    'checkoutInquiry.select_address': 'Sélectionnez une adresse',
    'checkoutInquiry.address_add': 'Ajouter une adresse',
    'checkoutInquiry.address_hint':
      "Nous n'avons trouvé aucune adresse. Ajoutez-en une via l'application mobile ou contactez le support.",
    'checkoutInquiry.address_label': 'Adresse',
    'checkoutInquiry.address_no_details':
      "Aucun détail d'adresse disponible.",
    'checkoutInquiry.delivery_label': 'Instructions de livraison',
    'checkoutInquiry.delivery_placeholder': 'Ajoutez des notes de livraison',
    'checkoutInquiry.summary_items': 'Articles',
    'checkoutInquiry.summary_subtotal': 'Sous-total',
    'checkoutInquiry.summary_shipping': 'Livraison',
    'checkoutInquiry.summary_total': 'Paiement total',
    'checkoutInquiry.submitting': 'Envoi…',
    'checkoutInquiry.submit': 'Confirmer et envoyer',
    'checkoutInquiry.place_order_error_missing_customer':
      'Informations client manquantes. Veuillez vous reconnecter.',
    'checkoutInquiry.place_order_error_generic':
      'Impossible de passer la commande. Veuillez réessayer.',
    'checkoutInquiry.shipping_tbd': 'À déterminer',
    'checkoutInquiry.shipping_included': 'Inclus',
    'add_address.browser_only':
      'Google Maps est disponible uniquement dans le navigateur.',
    'add_address.missing_api_key': "Clé API Google Maps manquante.",
    'add_address.maps_key_missing':
      'La clé Google Maps n’est pas configurée. Veuillez saisir les coordonnées manuellement.',
    'add_address.maps_load_error':
      'Impossible de charger Google Maps. Veuillez saisir les coordonnées manuellement.',
    'add_address.sign_in_required':
      'Veuillez vous reconnecter avant d’ajouter une adresse.',
    'add_address.required_fields':
      'Le nom et la ville sont obligatoires.',
    'add_address.save_error':
      'Impossible d’enregistrer cette adresse pour le moment. Veuillez réessayer.',
    'add_address.title': 'Nouvelle adresse',
    'add_address.edit_title': "Modifier l'adresse",
    'add_address.close': 'Fermer',
    'add_address.name_label': 'Nom de l’adresse *',
    'add_address.name_placeholder': 'ex. Maison, Bureau',
    'add_address.street_label': 'Rue',
    'add_address.street_placeholder': 'Rue principale',
    'add_address.building_label': 'Bâtiment',
    'add_address.building_placeholder': 'Bâtiment',
    'add_address.apartment_label': 'Appartement',
    'add_address.apartment_placeholder': 'Appartement',
    'add_address.city_label': 'Ville *',
    'add_address.city_placeholder': 'Ville',
    'add_address.description_label': 'Description du lieu',
    'add_address.description_placeholder': 'Points de repère, directions…',
    'add_address.pin_label': 'Placer sur la carte *',
    'add_address.search_placeholder': 'Rechercher un lieu au Liban',
    'add_address.searching': 'Recherche…',
    'add_address.cancel': 'Annuler',
    'add_address.save': 'Enregistrer',
    'add_address.saving': 'Enregistrement…',
    'add_address.pin_required': 'Veuillez sélectionner un point sur la carte.',
    'support.title': 'Contactez-nous',
    'support.description':
      'Pour plus d’informations sur nos produits et services, laissez-nous un message. Notre équipe est toujours là pour vous aider.',
    'support.contact_us': 'Contactez-nous',
    'support.email': 'Email',
    'support.image_alt': 'Illustration du support client',
    'support.form.name': 'Nom complet',
    'support.form.name_placeholder': 'Votre nom',
    'support.form.phone': 'Numéro de téléphone',
    'support.form.phone_placeholder': '+1 555 000 000',
    'support.form.email': 'Adresse e-mail',
    'support.form.email_placeholder': 'vous@email.com',
    'support.form.subject': 'Sujet',
    'support.form.message': 'Message',
    'support.form.message_placeholder': 'Votre message',
    'support.form.submit': 'Envoyer le message',
    'support.form.submitting': 'Envoi…',
    'support.form.validation_error':
      'Veuillez saisir votre nom, votre numéro de téléphone et votre message.',
    'support.form.success':
      'Votre message a été envoyé. Nous vous contacterons sous peu.',
    'support.form.error_generic':
      'Une erreur est survenue. Veuillez réessayer plus tard.',
    'support.subject_picker.title': 'Choisir un sujet',
    'support.subject_picker.close': 'Fermer',
    'support.subject.other': 'Autre',
    'support.subject.order': 'Problème de commande',
    'support.subject.payment': 'Paiement',
    'support.subject.general': 'Général',
    'faq.title': 'Questions fréquemment posées',
    'faq.description': 'Trouvez des réponses rapides aux questions courantes sur les services Wassini.',
    'faq.loading': 'Chargement des questions…',
    'faq.empty': 'Aucune FAQ trouvée pour le moment.',
    'faq.select_prompt': 'Sélectionnez une question pour voir la réponse.',
    'search.results_title': 'Résultats de recherche',
    'search.results_subtitle': 'Affichage des correspondances pour « {query} »',
    'search.no_query': 'Saisissez un mot-clé pour rechercher des produits, marques ou catégories.',
    'search.preview_no_results': 'Aucun résultat pour le moment.',
    'search.loading': 'Recherche en cours…',
    'search.view_more': 'Voir plus de résultats',
    'search.submit': 'Rechercher',
    'search.products_label': 'Produits',
    'search.brands_label': 'Marques',
    'search.categories_label': 'Catégories',
    'search.no_results': 'Aucun résultat trouvé.',
    'orders.title': 'Historique des commandes',
    'orders.filter.pending': 'En attente',
    'orders.filter.completed': 'Terminées',
    'orders.empty_pending': "Vous n'avez aucune commande en attente.",
    'orders.empty_completed': 'Aucune commande terminée pour le moment.',
    'orders.loading': 'Chargement des commandes…',
    'orders.columns.id': 'Numéro',
    'orders.columns.date': 'Dates',
    'orders.columns.status': 'Statut',
    'orders.columns.price': 'Prix',
    'orders.status.pending': 'En attente',
    'orders.status.completed': 'Terminée',
    'addresses.select':' Sélectionner l’adresse de livraison'
   
  },
};

export const normalizeLanguage = (code) =>
  LANGUAGE_SET.has(code) ? code : DEFAULT_LANGUAGE;

export const getStoredLanguage = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_LANGUAGE;
  }
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return normalizeLanguage(stored);
};

export const persistLanguage = (language) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, normalizeLanguage(language));
};

export const translateMessage = (language, key) => {
  const table = TRANSLATIONS[language] || {};
  if (table[key]) {
    return table[key];
  }
  const fallback = TRANSLATIONS[DEFAULT_LANGUAGE] || {};
  return fallback[key] || key;
};
